import React from 'react';
import { Section } from './Section';
import { BookOpen, ShoppingCart, Sparkles, Utensils, LineChart } from 'lucide-react';
export function WhatYouGetSection() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-forest" data-id="element-368" />,
    title: 'Guía de 3 días paso a paso',
    desc: 'Qué hacer desde que despiertas hasta que termina el día.'
  }, {
    icon: <ShoppingCart className="w-8 h-8 text-forest" data-id="element-369" />,
    title: 'Manual de supermercado en USA',
    desc: 'Lista práctica para comprar en Walmart, Target o Costco.'
  }, {
    icon: <Sparkles className="w-8 h-8 text-forest" data-id="element-370" />,
    title: 'Ritual de apoyo de 5 minutos',
    desc: 'Rutina sencilla para acompañar tu proceso y sentir más alivio corporal.'
  }, {
    icon: <Utensils className="w-8 h-8 text-forest" data-id="element-371" />,
    title: 'Guía para comer fuera de casa',
    desc: 'Opciones prácticas para no sabotearte cuando no cocinas.'
  }, {
    icon: <LineChart className="w-8 h-8 text-forest" data-id="element-372" />,
    title: 'Rastreador de progreso',
    desc: 'Para ver cambios y seguir tu avance durante las 72 horas.'
  }];
  return <Section className="bg-cream" data-id="element-373">
      <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-12 text-center" data-id="element-374">
        Esto es lo que obtienes hoy
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-375">
        {items.map((item, index) => <div key={index} className={`bg-white p-6 rounded-xl shadow-md border border-sage flex flex-col items-center text-center ${index === items.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-376">
            <div className="bg-sage w-16 h-16 rounded-full flex items-center justify-center mb-4" data-id="element-377">
              {item.icon}
            </div>
            <h3 className="font-serif text-xl font-bold text-forest mb-2" data-id="element-378">
              {item.title}
            </h3>
            <p className="text-gray-600" data-id="element-379">{item.desc}</p>
          </div>)}
      </div>
    </Section>;
}